export default __webpack_public_path__ + "static/media/img-0764-slovenia-premium-face.872eadd3.png";